<script setup lang="ts">
import {onMounted, ref} from "vue";
import {PageOpenIn} from "@enums/PageOpenIn";
import RouterService from "@/services/RouterService";
// @ts-ignore
import AppController from "@target/components/App/ts/AppController";
import {useI18n} from "vue-i18n";
import PopupNavbar from "@components/popup/popup-navbar/PopupNavbar.vue";
import ViewRulesController from "@/views/v2/rules/ViewRulesController";
import {f7} from "framework7-vue";
import {computed} from "@vue/reactivity";
import LangService from "@/services/LangService";

const self = ref(null);
const vc = ViewRulesController.of();
const {t} = useI18n({useScope: 'global'});
const {openIn, insidePopup, url} = vc;
const routerService: RouterService = AppController.getInstance().routerService;
const popupTitle = ref(t("page-rules.navbar.title"));
const loading = ref(true);
const iFrameUrl = computed(() => {
    if (url.value) {
        return url.value + `?lang=${LangService.getInstance().get()}&t=${Date.now()}`;
    }
    return null;
});

function toBack() {
    if (openIn.value === PageOpenIn.PAGE) {
        if (!insidePopup.value) {
            routerService.toBack();
        } else {
            // @ts-ignore
            f7.views.higher.router.back("/higher");
        }
    } else {
        if (insidePopup.value) {
            routerService.toBack();
        } else {
            // @ts-ignore
            f7.views.higher.router.back("/higher");
        }
    }
}

onMounted(() => {
    const iframe: HTMLElement | null = document.getElementById("iframe");
    if (iframe) {
        iframe.addEventListener("load", () => {
            loading.value = false;
            setTimeout(() => {
                iframe.style.opacity = '1';
            }, 314);
        });
    }
})

async function pageBeforeIn() {
    increaseHeightIfPopup();
}

function pageBeforeOut() {
    minimizeHeightIfPopup();
}

function increaseHeightIfPopup() {
    const popupHTML = document.querySelector('.popup-router-open-in');
	if (popupHTML) {
		popupHTML.classList.add('height-100');
	}
}

function minimizeHeightIfPopup() {
    const popupHTML = document.querySelector('.new-payment-popup');
    if (popupHTML) {
        popupHTML.classList.remove('height-100');
    }
}
</script>

<template>
    <f7-page
        ref="self"
        class="view-rules"
        :page-content="false"
        :class="[{'view-like-popup': openIn === PageOpenIn.POPUP && insidePopup}]"
        @page:beforein="pageBeforeIn"
        @page:beforeout="pageBeforeOut"
    >
        <popup-navbar
            :title="popupTitle"
            v-if="openIn === PageOpenIn.POPUP && insidePopup"
            @on-left-click="toBack"
        />
        <f7-navbar v-if="openIn === PageOpenIn.PAGE || openIn === PageOpenIn.POPUP && !insidePopup">
            <f7-nav-left>
                <a href="#" class="link icon-only" @click="toBack">
                    <i v-if="openIn === PageOpenIn.POPUP" class="icon i-svg-icon-close"></i>
                    <i v-else class="icon icon-back"></i>
                </a>
            </f7-nav-left>
            <f7-nav-title>
                {{ popupTitle }}
            </f7-nav-title>
        </f7-navbar>
        <f7-page-content>
            <div class="loading-wrapper" v-if="loading">
                <f7-preloader/>
            </div>
            <iframe
                :key="iFrameUrl"
                id="iframe"
                class="iframe"
                :src="iFrameUrl"
            />
        </f7-page-content>
    </f7-page>
</template>

<style lang="scss">
.view-rules {
    --f7-page-bg-color: #FFF;

    &.view-like-popup {
        padding-top: 24px;
        padding-bottom: 0;

        .page-content {
            padding-bottom: max(env(safe-area-inset-bottom), 24px);
        }
    }

    .page-content {
        position: relative;
        display: flex;
        flex-direction: column;
        overflow: auto;
        flex-grow: 1;
        padding-bottom: 0;

        .loading-wrapper {
            display: flex;
            justify-content: center;
            margin-top: 32px;
        }

        &::-webkit-scrollbar {
            width: 0;
        }

        .iframe {
            height: 100%;
            width: 100%;
            border: none;
            opacity: 0;
            transition: opacity 400ms ease;
        }
    }
}
</style>
